import { render, staticRenderFns } from "./bought.vue?vue&type=template&id=5a3d64a9&"
import script from "./bought.vue?vue&type=script&lang=js&"
export * from "./bought.vue?vue&type=script&lang=js&"
import style0 from "./bought.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports